import { useEffect } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import ooeConstants from '../../constants';
import theme from '../../theme';
import Footer from '../Footer/Footer';
import { notifyBugsnag } from '../../services/bugsnag';
import Icon from '../Icon';
import { Typography } from '@cfa/react-components';

const UnrecoverableError = () => {
  useEffect(() => {
    notifyBugsnag('Unrecoverable error view displayed', {
      context: 'Unrecoverable Error',
      message:
        'This exists as a way to analyze and diagnose the path that led a user to the Uncoverable Error screen',
    });
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <>
        <StyledUnrecoverableError>
          <Typography variant="h3" gutterBottom>
            Oops!
          </Typography>
          <Typography style={{ color: theme.text }}>
            <Icon className="icon">error</Icon>
            {ooeConstants.unrecoverableError()}
          </Typography>
        </StyledUnrecoverableError>
        <Footer>{`Version ${ooeConstants.APP_VERSION}`}</Footer>
      </>
    </ThemeProvider>
  );
};

const StyledUnrecoverableError = styled.div`
  padding: 5em;

  & .icon {
    height: 12px;
    width: 12px;
    margin: 0 2px;
  }
`;

export default UnrecoverableError;
